import { render, staticRenderFns } from "./OrderCheckFlowInfo.vue?vue&type=template&id=5b26f8f4&"
import script from "./OrderCheckFlowInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderCheckFlowInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports